import type { ItemDef } from './types'

/** Shield Bubble: the next hit within `durationTicks` only pops the shield (see `hit()`). */
export const shieldBubble: ItemDef = {
  id: 'shield_bubble',
  use(world, i) {
    world.players[i]!.shieldUntil = world.tick + world.cfg.items.shieldBubble.durationTicks
  },
}
